module.exports = __webpack_public_path__ + "img/base_energy.53af0a1b.svg";